import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import HowItWorks from "./HowItWorks.png";
import "./SmartOptionsHowItWorks.css";
const data = [
  { id: 1, title: "Create option strategies with a single tap through basket trading." },
  { id: 2, title: "Select multiple indices (Nifty, Bank Nifty, Fin Nifty, and Midcap) and conveniently trade in options." },
  { id: 3, title: "Set various indicators (EMA, super trend, Bollinger band) and trade in options from single window." },
  { id: 4, title: "Track your P&L and order status simultaneously through your live trading in a single window." },
];
function SmartOptionsHowItWorks() {
  return (
    <>
      <section className="SmartOptionsHowItWork_section">
        <h2>How It Option Radar <span>Works?</span></h2>
        <Container>
          <div className="SmartOptionsHowItWork_grid">
            <Row>
              <Col lg={6} md={12}>
                {/* <img className="img-fluid" src={HowItWorks} alt="How It Works" /> */}
                <div className="SmartOptionsHowItWork_videopanel  ">
                <iframe  src="https://www.youtube.com/embed/xQqTGXoRe48?si=4ZcZbZXh2iThN6rl" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </Col>
              <Col lg={6} md={12}>
              <div  className="SmartOptionsHowItWork_grouppanel">
                {data.map((value, index) => {
                  return (
                    <div Key={index} className="SmartOptionsHowItWork_panel text-center">
                      <div className="SmartOptionsHowItWork_img">
                        <span className="fa fa-check"></span>
                      </div>
                        <h3>{value.title}</h3>
                      </div>
                    );
                    }
                    )
                    }
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
}
export default SmartOptionsHowItWorks;
